if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

/* ============================================================
   Pensualizei — Zoom por toque na galeria (mobile)  [v1]
   Anexado ao media-gallery.js. Escopo: pagina de produto.
   - Desktop mantem a lupa hover original (jQuery Zoom).
   - Mobile: tocar na imagem abre a ampliacao; dentro dela,
     pinca, duplo-toque e arraste para ver detalhes da estampa.
   Reversivel: remover deste ponto ate o fim do arquivo.
   ============================================================ */
(function () {
  'use strict';
  if (window.PensualizeiTouchZoom) return;
  window.PensualizeiTouchZoom = true;

  var SMALL = '(max-width: 749px)';
  function isSmall() { return window.matchMedia(SMALL).matches; }

  function injectStyles() {
    if (document.getElementById('ps-touch-zoom-styles')) return;
    var css = [
      '@media (max-width: 749px){',
      '#ex1{pointer-events:auto !important;}',
      '#ex1 img{pointer-events:auto !important;cursor:zoom-in;}',
      '.product-media-modal__content img{transform-origin:center center;will-change:transform;touch-action:pan-x;}',
      '.product-media-modal__content img.ps-zoomed{touch-action:none;position:relative;z-index:3;}',
      '.product-media-modal__content.ps-has-zoom{overflow:hidden !important;}',
      '.product-media-modal__hint{position:fixed;left:50%;bottom:18px;transform:translateX(-50%);z-index:5;',
      'padding:7px 14px;border-radius:999px;font-size:12px;line-height:1;color:#fff;background:rgba(0,0,0,.62);',
      'pointer-events:none;opacity:0;transition:opacity .25s ease;}',
      '.product-media-modal.ps-open .product-media-modal__hint{opacity:1;}',
      '}'
    ].join('');
    var style = document.createElement('style');
    style.id = 'ps-touch-zoom-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function bindOpeners() {
    if (!isSmall()) return;
    document.querySelectorAll('media-gallery .product__modal-opener').forEach(function (opener) {
      var img = opener.querySelector('img');
      var btn = opener.querySelector('button.product__media-toggle');
      if (!img || !btn || img.dataset.psOpenBound) return;
      img.dataset.psOpenBound = '1';
      try {
        if (window.jQuery) {
          var box = img.closest('.zoom');
          if (box) window.jQuery(box).trigger('zoom.destroy');
        }
      } catch (e) {}
      img.style.pointerEvents = 'auto';
      img.addEventListener('click', function (ev) {
        if (!isSmall()) return;
        ev.preventDefault();
        ev.stopPropagation();
        btn.click();
      });
    });
  }

  function enhanceImage(img) {
    if (img.dataset.psZoomReady) return;
    img.dataset.psZoomReady = '1';

    var content = img.closest('.product-media-modal__content');
    var scale = 1, tx = 0, ty = 0;
    var startDist = 0, startScale = 1;
    var startX = 0, startY = 0, startTx = 0, startTy = 0;
    var lastTap = 0, mode = null;
    var MAX = 4, DBL = 2.5;

    function apply() { img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
    function state(on) {
      img.classList.toggle('ps-zoomed', on);
      if (content) content.classList.toggle('ps-has-zoom', on);
    }
    function clamp() {
      var mx = (img.clientWidth * (scale - 1)) / 2;
      var my = (img.clientHeight * (scale - 1)) / 2;
      tx = Math.max(-mx, Math.min(mx, tx));
      ty = Math.max(-my, Math.min(my, ty));
    }
    function reset() { scale = 1; tx = 0; ty = 0; apply(); state(false); }
    img._psReset = reset;

    function dist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }

    img.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        mode = 'pinch'; startDist = dist(e.touches); startScale = scale; e.preventDefault();
      } else if (e.touches.length === 1) {
        var now = Date.now();
        if (now - lastTap < 300) {
          e.preventDefault();
          if (scale > 1) { reset(); } else { scale = DBL; state(true); apply(); }
          lastTap = 0; mode = null; return;
        }
        lastTap = now;
        if (scale > 1) {
          mode = 'pan';
          startX = e.touches[0].clientX; startY = e.touches[0].clientY;
          startTx = tx; startTy = ty; e.preventDefault();
        }
      }
    }, { passive: false });

    img.addEventListener('touchmove', function (e) {
      if (mode === 'pinch' && e.touches.length === 2) {
        e.preventDefault();
        var d = dist(e.touches);
        if (startDist > 0) scale = Math.min(MAX, Math.max(1, startScale * (d / startDist)));
        state(scale > 1); clamp(); apply();
      } else if (mode === 'pan' && e.touches.length === 1 && scale > 1) {
        e.preventDefault();
        tx = startTx + (e.touches[0].clientX - startX);
        ty = startTy + (e.touches[0].clientY - startY);
        clamp(); apply();
      }
    }, { passive: false });

    img.addEventListener('touchend', function (e) {
      if (e.touches.length === 0) {
        if (scale <= 1.02) reset();
        mode = null;
      } else if (e.touches.length === 1) {
        mode = scale > 1 ? 'pan' : null;
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
        startTx = tx; startTy = ty;
      }
    });
  }

  function enhanceModal(modal) {
    if (!modal) return;
    modal.querySelectorAll('.product-media-modal__content img').forEach(enhanceImage);
    if (modal.dataset.psHint) return;
    modal.dataset.psHint = '1';

    var hint = document.createElement('div');
    hint.className = 'product-media-modal__hint';
    hint.textContent = 'Use pinca ou toque duplo para ampliar';
    modal.appendChild(hint);

    function resetAll() {
      modal.querySelectorAll('.product-media-modal__content img').forEach(function (im) {
        if (im._psReset) im._psReset();
      });
    }

    var close = modal.querySelector('.product-media-modal__toggle');
    if (close) close.addEventListener('click', function () {
      modal.classList.remove('ps-open');
      resetAll();
    });

    var mo = new MutationObserver(function () {
      if (modal.hasAttribute('open')) {
        modal.classList.add('ps-open');
      } else {
        modal.classList.remove('ps-open');
        resetAll();
      }
    });
    mo.observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  function init() {
    injectStyles();
    bindOpeners();
    document.querySelectorAll('product-modal.product-media-modal').forEach(enhanceModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  window.addEventListener('load', function () { setTimeout(init, 300); });
  document.addEventListener('shopify:section:load', init);
})();
